<template>
  <button type="submit" :id="id" class="ladda-button" :class="btnClass" data-style="expand-left"
          data-spinner-size="24" @click.prevent="onClick($event)" :isActive="postActive">
    <span class="ladda-label">
      <fa-icon v-if="iconFront" :icon="iconFront"/><span class="d-none d-sm-inline">&nbsp;&nbsp;</span>
      {{ text }}
      <span class="d-none d-sm-inline">&nbsp;&nbsp;</span><fa-icon v-if="iconBack" :icon="iconBack"/>
    </span>
  </button>
</template>

<script>
import * as Ladda from 'ladda'
import { API_POST_BUTTON, API_SET_POST_BUTTON } from '@/store/api/postStatus.types'

export default {
  props: {
    id: {type: String, required: true},
    text: {type: String, required: true},
    btnClass: {type: String, required: false, default: 'btn btn-primary'},
    onSubmit: {type: Function, required: false, default: null},
    onValidate: {type: Function, required: false, default: null},
    iconFront: {type: String, required: false},
    iconBack: {type: String, required: false}
  },

  data () {
    return {
      laddaBtn: null
    }
  },

  methods: {
    onClick (event) {
      if (this.onValidate) {
        if (!this.onValidate()) {
          return
        }
      }

      if (this.onSubmit) {
        this.setPostButton()
        setTimeout(() => {
          if (this.laddaBtn !== null && this.isPostActive()) {
            this.laddaBtn.start()
          }
        }, 300)

        this.onSubmit(event)
      }
    },

    isPostActive () {
      return this.$store.getters[API_POST_BUTTON] === this.id
    },

    setPostButton () {
      this.$store.commit(API_SET_POST_BUTTON, this.id)
    }
  },

  mounted () {
    let el = document.getElementById(this.id)
    if (el) {
      this.laddaBtn = Ladda.create(el)
    }
  },

  beforeDestroy () {
    if (this.laddaBtn !== null) {
      this.laddaBtn.remove()
      this.laddaBtn = null
    }
  },

  computed: {
    postActive () {
      if (this.laddaBtn !== null) {
        if (this.isPostActive()) {
          return true
        } else {
          if (this.laddaBtn.isLoading()) {
            this.laddaBtn.stop()
          }
        }
      }
      return false
    }
  },

  components: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/inputs/SignalButton.vue